import React, { PureComponent, Component } from 'react';

class ProcesamientoParcial extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            LimiteRechazos: props.data.proceso.LimiteRechazos
        };
        this.selectRadio = this.selectRadio.bind(this);

    }

    selectRadio(value) {
        this.props.selectRadio("ProcesamientoParcial", value)
    }

    onChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if ((regExp.test(value) || value.replace(/\s/g, "", "") == "")) {
            let newState = {
                [dataset.code]: value
            }
            this.setState(newState);

            this.props.changeInput(dataset.code, value);
        }
    }

    onBlur(event) {
        const { value, dataset } = event.target;

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            LimiteRechazos: nextProps.data.proceso.ProcesamientoParcial ? nextProps.data.proceso.LimiteRechazos : ""
        });
    }

    render() {

        const { proceso, ERROR_PROCESS } = this.props.data;

        return ( 
            <div className="row top-separator-xs">
                <div style={{marginLeft:"15px"}} className="form-group bottom-separator-xs">
                    <div className="col-md-12 no-padding-left">
                        <label className="label-primary">
                            ¿Permite procesamiento parcial?
                       </label>
                    </div>
                    <div>  
                        
                    <div className="row row-radio">
                        <div style={{marginLeft:"4px"}} className="col-xs-12">
                            <div className="container-radio radio-margin">
                                <input id={"rbProcesamiento" + 1}
                                    type="radio"
                                    name="rbProcesamiento"
                                    value={true}
                                    checked={proceso.ProcesamientoParcial == true}
                                    onChange={(event) => this.selectRadio(true)} />
                                        <label
                                    className="lbl-radio label-secondary"
                                    htmlFor={"rbProcesamiento" + 1}>
                                    {"SÍ"}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-4" style={{marginLeft:"-25px"}}>
                            <label className="lbl-radio label-secondary">{"Cantidad máxima de registros rechazados"}</label>
                        </div>
                        <div className="col-xs-2" style={{marginLeft:"-60px"}}>
                            <input className="form-control form-control-tarjetas input-Short"
                                maxLength={3}
                                value={this.state.LimiteRechazos}
                                data-code="LimiteRechazos"
                                data-validation="^([0-9]?\d|100)$"
                                disabled={proceso.ProcesamientoParcial == false}
                                onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                            />
                        </div>
                        <div className="col-xs-4" style={{marginLeft:"-135px"}}>
                            <label className="lbl-radio label-secondary">{"(Entre 1 y 100)"}</label>
                        </div>
                    </div>
                    <div className="row row-radio">
                        <div style={{marginLeft:"4px"}} className="col-xs-12">
                            <div className="container-radio radio-margin">
                                <input id={"rbProcesamiento" + 2}
                                    type="radio"
                                    name="rbProcesamiento"
                                    value={false}
                                    checked={proceso.ProcesamientoParcial == false}
                                    onChange={(event) => this.selectRadio(false)} />
                                        <label
                                    className="lbl-radio label-secondary"
                                    htmlFor={"rbProcesamiento" + 2}>
                                    {"NO"}
                                </label>
                            </div>
                        </div>
                    </div> 

                    {!ERROR_PROCESS["seleccionoPorcesamientoParcial"] &&
                    <label className="error">{"Debe completar la cantidad máxima de registros rechazados con un número entero mayor a cero."}</label>}

                    </div>
                </div>
            </div> 
        )
    }
};

export default ProcesamientoParcial;